import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from 'src/app/services/api/product.service';
import { WinService } from 'src/app/services/win.service';

@Component({
  selector: 'app-transparent-sticker',
  templateUrl: './transparent-sticker.component.html',
  styleUrls: ['./transparent-sticker.component.scss']
})
export class TransparentStickerComponent implements OnInit {

	@Input() product: any = null;
	@Input() bg: any = null;

	constructor(
		public productService: ProductService,
		public winService: WinService
	) { }

	ngOnInit(): void {
	}

}
